import { render, staticRenderFns } from "./scanfailinfo.vue?vue&type=template&id=31f47e8e&scoped=true&"
import script from "./scanfailinfo.vue?vue&type=script&lang=js&"
export * from "./scanfailinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f47e8e",
  null
  
)

export default component.exports